// src/components/Header/hooks/useHeaderChatActions.js
// import chatApi from '../../../api/chatApi';
// import {
//   setDialogId, setMessages, setRatingMessageId, setMode,
//   setDialogs, setIsAwaitingRole
// } from '../../ChatApp/chatSlice';
// import { selectUserId } from '../../Login/loginSlice';
// import { useSocket } from '../../ChatApp/useSocket';
import chatApi from '../api/chatApi';
import { useDispatch, useSelector } from 'react-redux';
import {
  setDialogId, setMessages, setRatingMessageId, setMode,
  setDialogs, setIsAwaitingRole
} from '../components/ChatApp/chatSlice';
import { selectUserId } from '../components/Login/loginSlice';
import { useSocket } from '../components/ChatApp/useSocket';

export const useHeaderChatActions = () => {
  const dispatch = useDispatch();
  const userId = useSelector(selectUserId);
  const auth = { userId };
  const { socket } = useSocket(auth);

  const fetchDialogs = async () => {
    const res = await chatApi.getUserDialogs(userId);
    dispatch(setDialogs(res.data.dialogs));
  };

  const handleStartNewDialog = async () => {
    try {
      const res = await chatApi.startNewDialog(userId);
      const dialogId = res.data.dialogId;
      dispatch(setDialogId(dialogId));

      if (!socket) {
        console.warn('Socket not ready — cannot join new dialog', dialogId);
      } else if (!socket.connected) {
        console.warn('Socket not connected — joinDialog skipped', dialogId);
      } else {
        socket.emit('joinDialog', { dialogId }, (ack) => {
          if (!ack || ack?.status !== 'ok') {
            console.warn('joinDialog ack:', ack);
          }
        });
      }

      localStorage.setItem(`lastDialogId_${userId}`, dialogId);
      dispatch(setMessages([]));
      dispatch(setRatingMessageId(null));
      dispatch(setMode('chat'));
      fetchDialogs();
    } catch (err) {
      console.error('Ошибка создания нового диалога:', err);
    }
  };

  const handleStartProcessingMessageToLawyer = () => {
    dispatch(setIsAwaitingRole(true));
  };

  return { handleStartNewDialog, handleStartProcessingMessageToLawyer };
};
